export default __webpack_public_path__ + "static/koen-648c0ea55ae42dc3945f2ef069f8e8bd.png";